module.exports = __webpack_public_path__ + "img/dg-nav-below-nav-ford.e5d231ee.png";